import z from "zod";
import { VacancyOptimizedSchema, VacancySchema } from "./vacancy.dto";
import { CompanyMediaSchema } from "./company-media.dto";

export const CompanySchema = z.object({
    id: z.string(),
    name: z.string(),
    fieldOfActivity: z.string().optional().nullable(),
    address: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    description: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    site: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    vacancies: z.array(VacancySchema),
    companyMedias: z.array(CompanyMediaSchema),
});
export type CompanyDTO = z.infer<typeof CompanySchema>;

export const CompanyOptimizedSchema = z.object({
    id: z.string(),
    name: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    vacancies: z.array(VacancyOptimizedSchema),
});
export type CompanyOptimizedDTO = z.infer<typeof CompanyOptimizedSchema>;
